import {createTheme} from "@mui/material";

export const BACKGROUND_LIGHT = "#F8F8F8";

export const THEME = createTheme({
    typography: {
        button: {
            textTransform: "none"
        },
        fontFamily: 'Lato',
        MuiButtonBase: {
            styleOverrides: {
                textTransform: 'none',
                fontFamily: "Lato",
                fontWeight: 600
            },
        },

    },
    palette: {
        primary: {
            main: "#4c45ee",
            contrastText: "rgba(255, 255, 255, 1)"
        },
        standard: {
            main: "#0d0c36",
            contrastText: "rgba(255, 255, 255, 1)"
        },
        grayed: {
            main: "#CCCCCC",
        },
        dark: {
            main: "#888888",
        },
        highlight: {
            main: "#00AB41",
        }
    }
});
